import { createContext, useContext } from "react";

/**
 * Where a `FileViewer` puts the window it opens.
 *
 * - `inline` — the window is rendered by the trigger itself and is unmounted
 *   with it. The default, and what every surface with a stable trigger wants.
 * - `shared` — the window is opened in the floating-window store, so its
 *   lifetime is the store's rather than the trigger's. For surfaces that
 *   re-create their triggers underneath an open viewer: the unified copilot
 *   re-derives its trace on every 1s poll, which replaces the components
 *   holding an inline window and takes the open viewer down with them.
 */
export type FileViewerWindowMode = "inline" | "shared";

export const FileViewerWindowModeContext =
  createContext<FileViewerWindowMode>("inline");

export const useFileViewerWindowMode = (): FileViewerWindowMode =>
  useContext(FileViewerWindowModeContext);
